import { Field, Form, FormikProvider, useFormik, ErrorMessage } from "formik";
import { useEffect, useState } from "react";
import * as pri from "react-bootstrap";
import * as Yup from "yup";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import { CommonAxiosGet, CommonAxiosGetPdf } from "../../../CommonUtils/CommonAxios";
import { config } from "../../../CommonUtils/CommonURLS";
import Header from "../../../Layout/Header";
import PublicHeaderPanchayat from "../../../Layout/PublicHeaderPanchayat";
import { useLocation, useNavigate } from "react-router-dom";
import { TbArrowBackUp } from "react-icons/tb";
import { getOutsideDistrict, getOutsideMandals, getOutsideSecretariatDetails } from "../../../CommonUtils/CommonGetApis";
import Swal from "sweetalert2";
import MiscellaneousCitizenView from "./MiscellaneousCitizenView";
import { CommonPdfOpen } from "../../../CommonUtils/CommonPdf";

const MiscellaneousFeePayment = () => {

    const location = useLocation();
    const currentPath = location.pathname;

    const [openPdf, setOpenPdf] = useState("close");
    const [miscNo, setMiscNo] = useState(null);


    const subCategoryMap = {
        "/MiscellaneousFeeCertificate": 4,   // Certificates
         "/MiscellaneousFeeCertificateLogin": 4,   
        "/MiscellaneousFeeDeposit": 5,  // Deposits
           "/MiscellaneousFeeDepositLogin": 5,  // Deposits
        "/MiscellaneousFeeSalesGp": 7,
         "/MiscellaneousFeeSalesGpLogin": 7,

        "/MiscellaneousFeeNOCCertificate": 9,  // NOC Certificate
         "/MiscellaneousFeeNOCCertificateLogin": 9,  // NOC Certificate
        "/MiscellaneousFeeRTIDocument": 8,     // Other Fees
        
         "/MiscellaneousFeeRTIDocumentLogin": 8,     // Other Fees
        "/MiscellaneousFeeGarbage": 8,         // Other Fees
            "/MiscellaneousFeeGarbageLogin": 8,         // Other Fees
        "/MiscellaneousFeePenalties": 8,
         "/MiscellaneousFeePenaltiesLogin": 8  ,      // Other Fees// Other Fees
        "/MutationFeePayment": 100,
        "/PropertyValuationFeePayment": 99
    };
    const subCategoryId = subCategoryMap[currentPath];
    console.log("subCategoryId",subCategoryId);

    const pageTitleMap = {
        "/MiscellaneousFeeCertificate": "Miscellaneous Payment for Certificates",
            "/MiscellaneousFeeCertificateLogin": "Miscellaneous Payment for Certificates",
        "/MiscellaneousFeeDeposit": "Miscellaneous Payment for Deposits",
         "/MiscellaneousFeeDepositLogin": "Miscellaneous Payment for Deposits",
        "/MiscellaneousFeeSalesGp": "Miscellaneous Payment for Sale Of GP Produces",
          "/MiscellaneousFeeSalesGpLogin": "Miscellaneous Payment for Sale Of GP Produces",

        "/MiscellaneousFeeNOCCertificate": "Miscellaneous Payment for No Objection Certificate (NOC) Fee Industries",
         "/MiscellaneousFeeNOCCertificateLogin": "Miscellaneous Payment for No Objection Certificate (NOC) Fee Industries",
        "/MiscellaneousFeeRTIDocument": "Miscellaneous Payment for RTI Document",
         "/MiscellaneousFeeRTIDocumentLogin": "Miscellaneous Payment for RTI Document",
        "/MiscellaneousFeeGarbage": "Miscellaneous Payment for Garbage Collection",
          "/MiscellaneousFeeGarbageLogin": "Miscellaneous Payment for Garbage Collection",
        "/MiscellaneousFeePenalties": "Miscellaneous Payment for Fines / Penalties",
         "/MiscellaneousFeePenaltiesLogin": "Miscellaneous Payment for Fines / Penalties",
        "/MutationFeePayment": "Mutation Fee Payment",
         "/PropertyValuationFeePayment": "Property Valuation Certificate Fee Payment"
    };
    const pageTitle = pageTitleMap[currentPath] || "Miscellaneous Services";

    const childrenmouduleid_gen = useSelector((state) => state.reducers?.commonmastersreducer?.childrenmouduleid);
    const RoleId = useSelector((state) => state.reducers?.commonmastersreducer?.dualroles);
    const outside_district_gen = useSelector((state) => state.reducers?.commonmastersreducer?.outside_district);
    const outside_mandals_gen = useSelector((state) => state.reducers?.commonmastersreducer?.outside_mandals);
    const outside_secretariats_gen = useSelector((state) => state.reducers?.commonmastersreducer?.outside_secretariats);

    const [sectariatlist_gen, setsectariatlist_gen] = useState([]);
    const [citizenData, setCitizenData] = useState([]);


    const isRoleOne = parseInt(RoleId) === 1;

    // --------- FORM VALIDATION --------- //
    const validation = Yup.object().shape({
        district: Yup.string().when([], {
            is: () => !isRoleOne,
            then: Yup.string().required("District is required"),
        }),
        mandal: Yup.string().when([], {
            is: () => !isRoleOne,
            then: Yup.string().required("Mandal is required"),
        }),
        panchayat: Yup.string().required("Panchayat is required"),
        // purposecategoryId: Yup.string().required("Miscellaneous Type is required"),
        searchType: Yup.string().required("Please select search type"),
        searchValue: Yup.string().required("Enter search value")

    });

    // --------- FORM --------- //
    const formik = useFormik({
        initialValues: {
            district: "",
            mandal: "",
            panchayat: "",
             purposecategoryId: subCategoryId==100?102:99?103:"",
            searchType: "",
            searchValue: ""
        },
        validationSchema: validation,
        onSubmit: () => {
            console.log("Data:", formik.values);
            console.log("formikvalues",formik?.values?.purposecategoryId);


            let payload={
                    secId:formik?.values?.panchayat,
                    appRefNo:formik?.values?.searchType==="referenceNo"?formik?.values?.searchValue:"",
                    applName:formik?.values?.searchType==="referenceName"?formik?.values?.searchValue:"",
                    aadharNo:formik?.values?.searchType==="aadhaar"?formik?.values?.searchValue:"",
                    mobileNo:formik?.values?.searchType==="mobile"?formik?.values?.searchValue:"",
                }


            if(formik?.values?.purposecategoryId==""){
                Swal.fire("Please Select PurposeCategory","","info")
            }

            if(formik?.values?.purposecategoryId==102){
                
              

                  axios.post(config.url.API_URL + "citizen-service/mutationSearchGet/"+formik?.values?.panchayat+"/"+formik?.values?.purposecategoryId, payload).then((res) => {

                if (res?.data?.scode == "01") {
                    setCitizenData(res?.data?.data);
                }
                else if (res?.data?.scode == "02") {
                    Swal.fire(res?.data?.sdesc, "", "info");
                    setCitizenData([]);

                }
                else if (res?.data?.scode == "03") {
                    Swal.fire(res?.data?.sdesc, "", "info");
                    setCitizenData([]);
                }
            })


            }

              else if(formik?.values?.purposecategoryId==103){
                  axios.post(config.url.API_URL + "citizen-service/propertyValuationSearchGet/"+formik?.values?.panchayat+"/"+formik?.values?.purposecategoryId, payload).then((res) => {

                if (res?.data?.scode == "01") {
                    setCitizenData(res?.data?.data);
                }
                else if (res?.data?.scode == "02") {
                    Swal.fire(res?.data?.sdesc, "", "info");
                    setCitizenData([]);
                }
                else if (res?.data?.scode == "03") {
                    Swal.fire(res?.data?.sdesc, "", "info");
                    setCitizenData([]);
                }
            })


            }
            else {
            axios.post(config.url.API_URL + "citizen-service/miscellaneous-details", formik?.values).then((res) => {

                if (res?.data?.scode == "01") {
                    setCitizenData(res?.data?.data);
                }
                else if (res?.data?.scode == "02") {
                    Swal.fire(res?.data?.sdesc, "", "info");
                    setCitizenData([]);

                }
                else if (res?.data?.scode == "03") {
                    Swal.fire(res?.data?.sdesc, "", "info");
                    setCitizenData([]);
                }
            })
        }
        },
    });

    // --------- API CALLS --------- //

    // 📌 INSIDE user → ONLY SECRETARIATS
    const fetchSecreDetails = async () => {
        try {
            const response = await CommonAxiosGet("getsecretratedetails");
            if (response?.data?.scode === "01") {
                setsectariatlist_gen(response.data.SecretraitDetails);
            }
        } catch (err) {
            console.log(err);
        }
    };


    function ClearAll() {
        formik?.setFieldValue("mandal", "")
        formik?.setFieldValue("panchayat", "")

    }

    function ClearPanchayatVillage() {
        formik?.setFieldValue("panchayat", "")

    }


 const handleDownloadReceipt = async (row) => {

        try {

            const assesNo = row?.miscellaneous_reference_no;
            const receiptNo = row?.receipt_no;
            const purcatId=row?.purposecategory_id;
            const subcatId=row?.subcategory_id;
            await CommonAxiosGetPdf(`taxnontaxpayment-pdf/${assesNo}/${receiptNo}/${purcatId}/${subcatId}`).then((res) => {
                CommonPdfOpen(res.data, assesNo + "_DOC");

            });

            // axios(config.url.API_URL + `taxnontaxpayment-pdf/${assessmentNo}/${transactionno}/${purposecategory_id}/${subcategory_id}`, {



        } catch (error) {
            console.log(error)
        }
    }


    // --------- INITIAL LOAD --------- //
    useEffect(() => {
        if (isRoleOne) {
            fetchSecreDetails();
        } else {
            getOutsideDistrict();
        }
    }, [isRoleOne]);

    const navigate = useNavigate();

    const [purposeCategories, setPurposeCategories] = useState([]);
    const fetchPurposeCategories = async () => {
        try {


            const res = await axios.get(config.url.API_URL + `citizen-service/miscellaneous-feeservice/${subCategoryId}`);

            if (res?.data?.scode === "01") {
                setPurposeCategories(res?.data?.data);
            }
        } catch (err) {
            console.log(err);
        }
    };


   

 useEffect(() => {
        setPurposeCategories([]);
        formik.resetForm();
        fetchPurposeCategories();
        
    }, [currentPath]);
    // ================= UI ================= //

    const labelMap = {
        referenceNo: "Reference No",
        referenceName: "Reference Name",
        aadhaar: "Aadhaar Number",
        mobile: "Mobile Number"
    };

    const handlePayData = (rowData) => {
        Swal.fire({
            title: "Proceed with Payment?",
            html: `
            <div style="font-size:15px; line-height:1.6; text-align:center; margin-top:5px;">
                <div>Reference No: <span style="font-weight:500">${rowData.miscellaneous_reference_no}</span></div>
                <div>Name: <span style="font-weight:500">${rowData.owner_name}</span></div>
                <div>Amount: <span style="font-weight:600; color:#198754;">₹ ${rowData.demand_amount}</span></div>
            </div>
        `,
            icon: "question",
            iconColor: "#0d6efd",
            showCancelButton: true,
            confirmButtonText: "Pay Now",
            cancelButtonText: "Cancel",
            confirmButtonColor: "#28a745",
            cancelButtonColor: "#dc3545",
            width: "450px",
            padding: "1.2rem 1rem",
            customClass: {
                title: "swal-title-custom",
                popup: "swal-popup-custom",
                confirmButton: "swal-confirm-btn",
                cancelButton: "swal-cancel-btn"
            }
        }).then((result) => {
            if (result.isConfirmed) {

                const values = formik.values;
                const payload = {
                    district: isRoleOne ? 0 : values.district,
                    mandal: isRoleOne ? 0 : values.mandal,
                    panchayat: values.panchayat,
                    purposecategoryId: values.purposecategoryId,
                    searchType: values.searchType,
                    searchValue: rowData?.miscellaneous_reference_no
                };

                axios.post(config.url.API_URL + "citizen-service/miscellaneous-payment", payload).then((res) => {

                    if (res?.data?.scode == "01") {

                        let resData = res?.data?.data; const form = document.createElement('form'); form.method = 'POST'; form.action = config?.url?.SBI_PAYMENT_URL;
                        const inputmerchantid = document.createElement('input'); inputmerchantid.type = 'hidden'; inputmerchantid.name = 'merchant_code'; inputmerchantid.id = 'merchant_code';
                        inputmerchantid.value = "PANCH_CFMS"; form.appendChild(inputmerchantid); const inputencryption = document.createElement('input'); inputencryption.type = 'hidden'; inputencryption.name = 'encdata';
                        inputencryption.id = 'encdata'; inputencryption.value = resData; form.appendChild(inputencryption); document.body.appendChild(form); form.submit();
                    }
                    else if (res?.data?.scode == "02") {
                        Swal.fire(res?.data?.sdesc, "", "info")
                    }
                    else if (res?.data?.scode == "03") {
                        Swal.fire(res?.data?.sdesc, "", "info")
                    }
                })
            }
        });
    };






    const handleViewData = (rowData) => {

        setMiscNo(rowData?.miscellaneous_reference_no);
        setOpenPdf("show");
    }

    return (

        <>

            {
                openPdf === "close" && <>

                    {!isRoleOne && <PublicHeaderPanchayat />}

                    <pri.Container style={{ marginTop: "74px" }}>
                        <pri.Row>
                            <pri.Col
                                xs={12} sm={12} md={12} lg={12} xl={12} xxl={12}
                                className="page-titlespacing d-flex justify-content-between align-items-center"
                            >
                                <div className="inner-herbpage-service-title1">
                                    <h1>{pageTitle}</h1>
                                </div>

                            <div className="ms-auto">
                                    {!isRoleOne &&
                                        <pri.Button
                                            type="button"
                                            className="btn-btn-success back-button"
                                            onClick={() => navigate("/SwarnaPanchayatServices")}
                                        >
                                            <TbArrowBackUp className="back-icon" /> Back
                                        </pri.Button>
                                    }

                                    {isRoleOne &&
                                        <pri.Button
                                            type="button"
                                            className="btn-btn-success back-button"
                                            onClick={() => navigate("/sidebar")}
                                        >
                                            <TbArrowBackUp className="back-icon" /> Back
                                        </pri.Button>
                                    }
                                </div>
                            </pri.Col>
                        </pri.Row>
                    </pri.Container>
                    <pri.Container style={{ marginTop: "50px" }}>
                        <FormikProvider value={formik}>
                            <Form onSubmit={formik.handleSubmit}>

                                <pri.Row className="mt-4">

                                    {/* ROLE ≠ 1 → DISTRICT */}
                                    {!isRoleOne && (
                                        <>
                                            <pri.Col xs={2}>
                                                <label>District<span className="text-danger">*</span></label>
                                            </pri.Col>
                                            <pri.Col xs={4}>
                                                <Field
                                                    as="select"
                                                    name="district"
                                                    className="form-select"
                                                    onChange={(e) => {
                                                        formik.handleChange(e);
                                                        getOutsideMandals(e.target.value);
                                                        ClearAll();
                                                    }}
                                                >
                                                    <option value="">--- Select District ---</option>
                                                    {outside_district_gen?.map((d) => (
                                                        <option key={d.district_id} value={d.district_id}>
                                                            {d.district_desc}
                                                        </option>
                                                    ))}
                                                </Field>
                                                <ErrorMessage name="district" className="text-danger" component="div" />
                                            </pri.Col>

                                            <pri.Col xs={2}>
                                                <label>Mandal <span className="text-danger">*</span></label>
                                            </pri.Col>
                                            <pri.Col xs={4}>
                                                <Field
                                                    as="select"
                                                    name="mandal"
                                                    className="form-select"
                                                    onChange={(e) => {
                                                        formik.handleChange(e);
                                                        getOutsideSecretariatDetails(
                                                            formik?.values?.district,
                                                            e.target.value
                                                        );
                                                        ClearPanchayatVillage();
                                                    }}
                                                >
                                                    <option value="">--- Select Mandal ---</option>
                                                    {outside_mandals_gen?.map((m) => (
                                                        <option key={m.mandal_id} value={m.mandal_id}>
                                                            {m.mandal_desc}
                                                        </option>
                                                    ))}
                                                </Field>
                                                <ErrorMessage name="mandal" className="text-danger" component="div" />
                                            </pri.Col>
                                        </>
                                    )}
                                    <pre></pre>
                                    {/* PANCHAYAT + PURPOSE CATEGORY */}
                                    <pri.Col xs={2}>
                                        <label>Panchayat <span className="text-danger">*</span></label>
                                    </pri.Col>
                                    <pri.Col xs={4}>
                                        <Field
                                            as="select"
                                            name="panchayat"
                                            className="form-select"
                                        >
                                            <option value="">--- Select Panchayat ---</option>

                                            {isRoleOne &&
                                                sectariatlist_gen?.map((p) => (
                                                    <option key={p.secretariat_id} value={p.secretariat_id}>
                                                        {p.secretariat_desc}
                                                    </option>
                                                ))}

                                            {!isRoleOne &&
                                                outside_secretariats_gen?.map((p) => (
                                                    <option key={p.secretariat_id} value={p.secretariat_id}>
                                                        {p.secretariat_desc}
                                                    </option>
                                                ))}
                                        </Field>
                                        <ErrorMessage name="panchayat" className="text-danger" component="div" />
                                    </pri.Col>
                                      {(subCategoryId==100||subCategoryId==99)?(<>
                                   
                                    </>):(<>
                                     <pri.Col xs={2}>
                                        <label>Purpose Category <span className="text-danger">*</span></label>
                                    </pri.Col>
                                    <pri.Col xs={4}>
                                        <Field as="select" name="purposecategoryId" className="form-select">
                                            <option value="">--- Select Purpose Category ---</option>
                                            {purposeCategories?.map((item) => (
                                                <option
                                                    key={item.purposecategory_id}
                                                    value={item.purposecategory_id}
                                                >
                                                    {item.purposecategory_desc}
                                                </option>
                                            ))}
                                        </Field>
                                        <ErrorMessage name="purposecategoryId" component="div" className="text-danger" />
                                    </pri.Col>
                                    </>)}

                                </pri.Row>
                                <pri.Row className="mt-3">
                                    <pri.Col xs={12}>
                                        <label className="form-label fw">Search By</label>
                                    </pri.Col>

                                    <pri.Col xs={12} className="d-flex gap-4">

                                        <label>
                                            <Field type="radio" name="searchType" value="referenceNo" />
                                            <span className="ms-1">Reference No</span>
                                        </label>

                                        <label>
                                            <Field type="radio" name="searchType" value="referenceName" />
                                            <span className="ms-1">Reference Name</span>
                                        </label>

                                        <label>
                                            <Field type="radio" name="searchType" value="aadhaar" />
                                            <span className="ms-1">Aadhaar No</span>
                                        </label>

                                        <label>
                                            <Field type="radio" name="searchType" value="mobile" />
                                            <span className="ms-1">Mobile No</span>
                                        </label>

                                    </pri.Col>


                                    <pri.Col xs={12}>
                                        <ErrorMessage
                                            name="searchType"
                                            component="div"
                                            className="text-danger"
                                        />
                                    </pri.Col>
                                </pri.Row>
                                <pri.Row className="mt-3 align-items-end">
                                    <pri.Col xs={4}>
                                        <label className="form-label">
                                            {labelMap[formik.values.searchType] || ""}
                                        </label>

                                        <Field
                                            name="searchValue"
                                            className="form-control"
                                            placeholder={
                                                formik.values.searchType
                                                    ? `Enter ${labelMap[formik.values.searchType]}`
                                                    : "Enter Value"
                                            }
                                        />

                                        <ErrorMessage name="searchValue" component="div" className="text-danger" />
                                    </pri.Col>

                                    <pri.Col xs={8} className="d-flex align-items-end gap-2">

                                        <button type="submit" className="btn btn-primary">Submit</button>

                                        <button
                                            type="button"
                                            className="btn btn-secondary"
                                            onClick={() => {
                                                formik.resetForm();
                                                setCitizenData([]);
                                            }}
                                        >
                                            Reset
                                        </button>
                                    </pri.Col>
                                </pri.Row>


                                {citizenData?.length > 0 ? (
                                    <pri.Table bordered responsive className="text-payment-table" style={{ marginTop: "20px" }}>
                                        <thead>
                                            <tr>
                                                <th className="text-center">S.No</th>
                                                <th className="text-center">Reference No</th>
                                                <th className="text-center">Name</th>
                                                {(formik?.values?.purposecategoryId==102||formik?.values?.purposecategoryId==103)&&<>
                                                 <th className="text-center">Assessment No</th>
                                                 <th className="text-center">Applicant Date</th>
                                                </>}
                                                <th className="text-center">Category</th>
                                                <th className="text-center">Financial Year</th>
                                                <th className="text-center">Mobile No</th>
                                                <th className="text-center">Due Fee(Rs.)</th>
                                                <th className="text-center">Action</th>
                                            </tr>
                                        </thead>

                                        <tbody>
                                            {citizenData?.length > 0 ? (
                                                citizenData.map((row, index) => {
                                                    const statusId = row.pymntstsid;

                                                    const isPending = [3, 4, 5, 10].includes(statusId);
                                                    const isPaid = [1, 5, 6, 7, 8, 9, 11, 12, 13, 14, 15].includes(statusId);




                                                    return (
                                                        <tr key={index}>
                                                            <td className="text-center">{index + 1}</td>
                                                            <td className="text-center">{(formik?.values?.purposecategoryId==102||formik?.values?.purposecategoryId==103)?row?.appl_ref_no:row.miscellaneous_reference_no}</td>
                                                            <td className="text-center">{row.owner_name}</td>
                                                            {(formik?.values?.purposecategoryId==102||formik?.values?.purposecategoryId==103)&&<>
                                                             <td className="text-center">{row.assessment_no}</td>
                                                            <td className="text-center">{row.appl_date}</td>
                                                            </>}
                                                            <td className="text-center">{row.category_desc}</td>
                                                            <td className="text-center">{row.financial_year}</td>
                                                            <td className="text-center">{row.mobile_no}</td>
                                                            <td className="text-center">{row.demand_amount}</td>

                                                            <td className="text-center">
                                                                <button className="btn btn-secondary btn-sm px-3 rounded-pill" onClick={() => { handleViewData(row) }}>View</button> {" "}
                                                                {/* {isPaid ? (
                                                                    <button className="btn btn-secondary btn-sm px-3 rounded-pill" disabled>
                                                                        Paid
                                                                    </button>
                                                                ) 
                                                                
                                                                : isPending ? (
                                                                    <button className="btn btn-warning btn-sm px-3 rounded-pill" disabled>
                                                                        Pending
                                                                    </button>
                                                                ) 
                                                                :  (
                                                                    <button
                                                                        className="btn btn-success btn-sm px-4 rounded-pill"
                                                                        type="button"
                                                                        onClick={() => handlePayData(row)}
                                                                    >
                                                                        Pay
                                                                    </button>

                                                                    
                                                                )} */}

                                                                {statusId === 1 ? (
                                                                    <button
                                                                        className="btn btn-info btn-sm px-3 rounded-pill"
                                                                        onClick={() => handleDownloadReceipt(row)}
                                                                    >
                                                                        Download Receipt
                                                                    </button>

                                                                ) : isPending ? (
                                                                    <button className="btn btn-warning btn-sm px-3 rounded-pill" disabled>
                                                                        Pending
                                                                    </button>

                                                                ) : isPaid ? (
                                                                    <button className="btn btn-secondary btn-sm px-3 rounded-pill" disabled>
                                                                        Paid
                                                                    </button>

                                                                ) : (
                                                                    
                                                                    <button
                                                                        className="btn btn-success btn-sm px-4 rounded-pill"
                                                                        type="button"
                                                                        onClick={() => handlePayData(row)}
                                                                        disabled={row?.demand_amount==0?true:false}
                                                                    >
                                                                        Pay
                                                                    </button>
                                                                )}



                                                            </td>
                                                        </tr>
                                                    );
                                                })
                                            ) : (
                                                <tr>
                                                    <td colSpan="8" className="text-center text-muted">
                                                        No records
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>

                                    </pri.Table>
                                ) : (
                                    <div></div>
                                )}


                            </Form>
                        </FormikProvider>
                    </pri.Container>
                </>
            }

            <>

                {openPdf === "show" && (
                    <div className="d-flex justify-content-center mt-3">
                        <div style={{ width: "70%", position: "relative" }}>


                            <pri.Button
                                variant="secondary"
                                style={{
                                    position: "absolute",
                                    top: "25px",
                                    right: "0px",
                                    zIndex: 1000,
                                    borderRadius: "20px",
                                    padding: "6px 16px",
                                    fontWeight: "500",
                                    boxShadow: "0 2px 6px rgba(0,0,0,0.25)",
                                }}
                                onClick={() => setOpenPdf("close")}
                            >
                                Back
                            </pri.Button>


                            <MiscellaneousCitizenView miscellaneousno={miscNo} />
                        </div>
                    </div>
                )}
            </>
        </>
    );
};

export default MiscellaneousFeePayment;
